import { BusinessExceptionMessage } from "src/app/shared/model/business-exception.model";
import { CustomerDto, CustomerSchema } from "./customer.model";
import { required } from "@corporate-tailwind/corp-form";

export class OrderIdentificationDto {
    customerDto: CustomerDto | null = null;
    businessExceptionMessages: BusinessExceptionMessage[] | null = null;
}

export class OrderIdentificationSchema extends OrderIdentificationDto {
    static schema = {
        customerDto: { type: CustomerSchema, builderOption: required }

    }
}
